import type { PropertySectionKey } from './propertySectionKeys';

/**
 * Section order for the default (homebuyer) property report view.
 * Matches the order the report has always rendered in.
 */
export const PROPERTY_REPORT_SECTION_ORDER_DEFAULT: PropertySectionKey[] = [
  'overview',
  'neighborhood_insights_banner',
  'professional_tools',
  'business_promo_row',
  'property_smart_insights',
  'property_details',
  'assessed_value_and_taxes',
  'know_your_neighborhood',
  'building_permits',
  'home_owner_association',
  'property_valuation',
  'possible_owners',
  'residents',
  'deeds',
  'property_liens',
  'market_insights',
  'property_demographics',
  'property_schools',
  'natural_hazards',
  'perks_banner',
  'pdf',
  'notes',
  'related_reports',
  'report_rating',
];

/**
 * Section order for the professional (real estate) property report view
 * (UPS-1260/UPS-1261). Per the ticket spec: Overview first, then Property
 * Valuation, Market Insights and Possible Owner move up front, and every
 * other section keeps the same relative order as the default view.
 */
export const PROPERTY_REPORT_SECTION_ORDER_PROFESSIONAL: PropertySectionKey[] =
  [
    'overview',
    'property_valuation',
    'market_insights',
    'possible_owners',
    'neighborhood_insights_banner',
    'professional_tools',
    'business_promo_row',
    'property_smart_insights',
    'property_details',
    'assessed_value_and_taxes',
    'know_your_neighborhood',
    'building_permits',
    'home_owner_association',
    'residents',
    'deeds',
    'property_liens',
    'property_demographics',
    'property_schools',
    'natural_hazards',
    'perks_banner',
    'pdf',
    'notes',
    'related_reports',
    'report_rating',
  ];
